import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurServices from "./sections/OurServices";
import PortfolioPreview from "./sections/PortfolioPreview";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import ScheduleYourAppointment from "./sections/ScheduleYourAppointment";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurServices />
      <PortfolioPreview />
      <CustomerTestimonials />
      <ScheduleYourAppointment />
      <Footer />
    </div>;
}